import _property from 'lodash/property';
import _isEmpty from 'lodash/isEmpty';
import _isUndefined from 'lodash/isUndefined';
import _orderBy from 'lodash/orderBy';
import _trim from 'lodash/trim';
import _get from 'lodash/get';
import { tget } from '@tekion/tekion-base/utils/general';
import { INTERNAL_LOOKUP_KEY } from '@tekion/tekion-base/bulkResolvers/constants/general';
import { RESOURCE_TYPE } from '@tekion/tekion-base/bulkResolvers/constants/resourceType';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var getCurrentUser = _property('currentUser');
var getCurrentUserId = _property('currentUser.id');
var getCurrentUserImage = _property('currentUser.image');
var getNoteId = _property('id');
var getNoteCreatedTime = _property('createdTime');
var getNoteModifiedTime = _property('modifiedTime');
var getNoteText = _property('text');
var getUserId = _property('userId');
var getUserImage = _property('profilePicture');
var getUserName = _property('displayName');
var getUserRole = _property('jobTitle');
var isNoteEdited = _property('modified');
var isNoteUnRead = _property('isUnread');
var isNoteEditable = function isNoteEditable(currentUser, note) {
  return getUserId(note) === getCurrentUserId({
    currentUser: currentUser
  });
};
var showEditor = function showEditor(_ref) {
  var isEditing = _ref.isEditing,
    isUpdate = _ref.isUpdate;
  return isEditing || isUpdate;
};
var showAvatar = function showAvatar(image) {
  return !_isUndefined(image);
};
var getButtonLabel = function getButtonLabel(_ref2) {
  var isUpdate = _ref2.isUpdate;
  return isUpdate ? __('Update') : __('Add');
};
var getNoteInput = function getNoteInput(noteInput) {
  return _trim(noteInput);
};
var isNoteValidText = function isNoteValidText(noteInput) {
  return _isEmpty(getNoteInput(noteInput));
};
var getNoteLength = function getNoteLength(notes) {
  return notes.length;
};
var getNotesOrderedByCreatedTime = function getNotesOrderedByCreatedTime(notes) {
  return _orderBy(notes, 'createdTime', 'desc');
};
var noteHasErrorMsg = function noteHasErrorMsg(validation) {
  return validation.message;
};
var isNotePinned = function isNotePinned(note) {
  return _get(note, 'pinned', false);
};
var tags = _property('tags');
var userId = _property('userId');
var taggedUsers = _property('taggedUsers');
var associatedUsers = function associatedUsers(note) {
  return tget(note[INTERNAL_LOOKUP_KEY], RESOURCE_TYPE.TENANT_USER_MINIMAL, EMPTY_OBJECT);
};
var owner = function owner(note) {
  return tget(associatedUsers(note), userId(note), EMPTY_OBJECT);
};
export default {
  getCurrentUser: getCurrentUser,
  getCurrentUserId: getCurrentUserId,
  getCurrentUserImage: getCurrentUserImage,
  getNoteId: getNoteId,
  getNoteCreatedTime: getNoteCreatedTime,
  getNoteModifiedTime: getNoteModifiedTime,
  getNoteText: getNoteText,
  getUserId: getUserId,
  getUserImage: getUserImage,
  getUserName: getUserName,
  getUserRole: getUserRole,
  isNoteEdited: isNoteEdited,
  isNoteUnRead: isNoteUnRead,
  isNoteEditable: isNoteEditable,
  showEditor: showEditor,
  showAvatar: showAvatar,
  getButtonLabel: getButtonLabel,
  getNoteInput: getNoteInput,
  isNoteValidText: isNoteValidText,
  noteHasErrorMsg: noteHasErrorMsg,
  getNoteLength: getNoteLength,
  isNotePinned: isNotePinned,
  getNotesOrderedByCreatedTime: getNotesOrderedByCreatedTime,
  tags: tags,
  owner: owner,
  taggedUsers: taggedUsers,
  associatedUsers: associatedUsers
};